import { render } from "./logo-com.vue?vue&type=template&id=7cfaf9d0"
import script from "./logo-com.vue?vue&type=script&lang=js"
export * from "./logo-com.vue?vue&type=script&lang=js"

import "./logo-com.vue?vue&type=style&index=0&id=7cfaf9d0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__